import React, {Component} from 'react';
import './ShareableLink.css';

class ShareableLink extends Component {
	constructor() {
		super();

		this.selectOnFocus = e => e.target.select();

		this.copyText = () => {
			this.inputEl.select();

			try {
				document.execCommand('copy');
			} catch (err) {
				console.error('Unable to copy');
			}
		};
	}

	render() {
		const {className, snippet} = this.props;

		return (
			<div className={`ShareableLink ${className || ''}`}>
				<input
					ref={el => (this.inputEl = el)}
					type="text"
					onFocus={this.selectOnFocus}
					value={snippet}
				/>
				<button ref={el => (this.buttonEl = el)} title="Copy to clipboard" onClick={this.copyText}>
					<span className="icon icon-content_copy" />
				</button>
			</div>
		);
	}
}

export default ShareableLink;



// WEBPACK FOOTER //
// ./src/widgets/ShareableLink.js